import { HttpHandler } from 'msw'

import { createSite } from './createSite'
import { deleteSite } from './deleteSite'
import { getAllSites } from './getAllSites'
import { getSite } from './getSite'
import { siteTypes } from './types'
import { updateSite } from './updateSite'
import { zones } from './zones'

export const sites: HttpHandler[] = [
    createSite,
    deleteSite,
    getAllSites,
    getSite,
    ...siteTypes,
    updateSite,
    ...zones,
]
